module.exports = {
  title: 'voltshare-web-app',
  baseUrl: '', // 测试项目地址
  baseApi: '', // 测试api请求地址
  pk:'pk_live_51IsUDRACObXSZo7MH938KqaTlC0FAmxcSHl1g9iM6WGVVXHZH65vofGmpwoDMX9RN5c1LlbTZ4PZaCI3RWsguvNH00h6L2EtzW',
  successUrl: "http://localhost:8080/#/success",
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static',
}
